/* tslint:disable */
/* eslint-disable */
/**
 * HCL Commerce Services - Account and Contract
 * These services provide APIs to manage accounts and contracts.  a contract is an agreement that represents the terms and conditions that apply to a transaction. An account is a relationship between the merchant and the financial institution that processes transactions for that merchant.
 *
 * The version of the OpenAPI document: 9.1.6
 * 
 * (C) Copyright HCL Technologies Limited 2021
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../../../../../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../../../../../base';
// @ts-ignore
import { GetDefaultStoreResponse } from '../../../../../com/hcl/commerce/typescript/axios';
/**
 * DefaultStoreGetApi - axios parameter creator
 * @export
 */
export const DefaultStoreGetApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * get the default store for a guest/registered user
         * @summary get the default store for a guest/registered user
         * @param {string} storeId The store identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        defaultStoreGet: async (storeId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('defaultStoreGet', 'storeId', storeId)
            const localVarPath = `/store/{storeId}/defaultStore/getDefaultStore`
                .replace(`{${"storeId"}}`, String(storeId));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultStoreGetApi - functional programming interface
 * @export
 */
export const DefaultStoreGetApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultStoreGetApiAxiosParamCreator(configuration)
    return {
        /**
         * get the default store for a guest/registered user
         * @summary get the default store for a guest/registered user
         * @param {string} storeId The store identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async defaultStoreGet(storeId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDefaultStoreResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.defaultStoreGet(storeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DefaultStoreGetApi - factory interface
 * @export
 */
export const DefaultStoreGetApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultStoreGetApiFp(configuration)
    return {
        /**
         * get the default store for a guest/registered user
         * @summary get the default store for a guest/registered user
         * @param {string} storeId The store identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        defaultStoreGet(storeId: string, options?: any): AxiosPromise<GetDefaultStoreResponse> {
            return localVarFp.defaultStoreGet(storeId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultStoreGetApi - object-oriented interface
 * @export
 * @class DefaultStoreGetApi
 * @extends {BaseAPI}
 */
export class DefaultStoreGetApi extends BaseAPI {
    /**
     * get the default store for a guest/registered user
     * @summary get the default store for a guest/registered user
     * @param {string} storeId The store identifier.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultStoreGetApi
     */
    public defaultStoreGet(storeId: string, options?: any) {
        return DefaultStoreGetApiFp(this.configuration).defaultStoreGet(storeId, options).then((request) => request(this.axios, this.basePath));
    }
}
